import { Component, forwardRef, Input } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormsModule,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgIf } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { ChipModule } from 'primeng/chip';
import { NotificationMessageService } from '../../../core/services/message.service';
import { IFileInput } from '../../interfaces/file.interface';

@Component({
    selector: 'eco-input-files',
    templateUrl: './eco-input-files.component.html',
    styleUrl: './eco-input-files.component.scss',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => EcoInputFilesComponent),
            multi: true,
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EcoInputFilesComponent),
            multi: true,
        },
    ],
    imports: [TranslateModule, NgIf, InputTextModule, ButtonModule, FormsModule, ChipModule]
})
export class EcoInputFilesComponent implements ControlValueAccessor, Validator {
  @Input() label: string = 'EMPTY';
  @Input() options: any;
  @Input() readonly: boolean = false;
  @Input() tooltip?: any;
  @Input() showLabel: boolean = true;
  @Input() disabled: boolean = false;
  @Input() accept: string | null = null;
  @Input() maxFileSize: number | null = null;
  @Input() multiple: boolean = true

  value: any;
  files: IFileInput[] = [];

  constructor(
    private messageService: NotificationMessageService,
    private translate: TranslateService,
  ) {}

  chooseFile(inputFile: HTMLInputElement) {
    inputFile.click();
  }

  onChange = (_value: IFileInput[]) => {};

  onTouched = () => {};

  writeValue(files: IFileInput[]): void {
    this.files = files ?? [];
  }

  registerOnChange(fn: (value: IFileInput[]) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }

  onChangeInput(event: any) {
    let fileInvalid: string[] = [];
    for (const file of event.target.files) {
      if (this.accept && !this.accept.includes(file.name.substring(file.name.lastIndexOf('.')))) {
        fileInvalid.push(file.name);
      } else {
        this.files.push({
          FileName: file.name,
          Content: file,
          ServerRelativeUrl: null,
        });
      }
    }
    this.onChange(this.files);
    if (fileInvalid.length > 0) {
      this.messageService.error(
        this.translate.instant('validateError.wrongFileFormat', { files: fileInvalid.join(', ') }),
      );
    }
  }

  onRemoveFile(index: number) {
    this.files.splice(index, 1);
    this.onChange(this.files);
  }
}
